import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import supportedLocales from '@/config/supported-locales';

Vue.use(VueI18n);

function loadLocaleMessages(): LocaleMessages {
    const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const localValidations = require.context('vee-validate/dist/locale', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: LocaleMessages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
            const localValidationMessages = localValidations(key);
            const validations = {
                code: matched[1].toString(),
                messages: { ...localValidationMessages.messages, ...locales(key).validations.messages },
            };
            messages[locale]['validations'] = validations;
        }
    });

    return messages;
}

function supportedLocalesInclude(locale: string) {
    return Object.keys(supportedLocales).includes(locale);
}

function getBrowserLocale() {
    if (window.location.href.includes('/pl/') || window.location.href.includes('lang=pl')) {
        return 'pl';
    }

    return 'en';
}

function getStartingLocale() {
    const browserLocale = getBrowserLocale();
    if (supportedLocalesInclude(browserLocale)) {
        return browserLocale;
    } else {
        return process.env.VUE_APP_I18N_LOCALE || 'en';
    }
}

export default new VueI18n({
    locale: getStartingLocale(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages(),
});
